import { Transport } from "src/tmc-yard/common/model/transport.model";

export class OptionsColumn {
    columnIndex: number;
    transportOptions = new Array<EditTransportOption>();
}

export class EditTransport {

    transport: Transport = new Transport();

    optionsChanged: boolean = false;
    updateRouting: boolean = false;
    updateRoutingPossible: boolean = false;
    registerEntranceEnabled: boolean = false;
    inPlanningMode: boolean = false;
    registerNow: boolean = false;
    restartRouting: boolean = false;
    restartRoutingPossible: boolean = false;

    selectedOptions = new Array<EditTransportOption>();

    constructor(edit?: any) {
        if (edit != null) {

            this.optionsChanged = edit.optionsChanged;
            this.updateRouting = edit.updateRouting;
            this.updateRoutingPossible = edit.updateRoutingPossible;
            this.registerEntranceEnabled = edit.registerEntranceEnabled;
            this.inPlanningMode = edit.inPlanningMode;
            this.restartRouting = edit.restartRouting;
            this.restartRoutingPossible = edit.restartRoutingPossible;
            this.registerNow = edit.registerNow;

            if (edit.transport != null) {
                this.transport = new Transport(edit.transport);
            }

            if (edit.selectedOptions != null) {
                for (const option of edit.selectedOptions) {
                    this.selectedOptions.push(new EditTransportOption(option));
                }
            }

        }
    }

}

export class EditTransportOption {

    id: number;
    amountOfPallettes: number;
    amountOfBoxes: number;
    amountInKilogramm: number;
    amountInLiter: number;
    amountOthers: string;

    transportOptions = new Array<EditTransportOption>();
    selectedParameterValues = new Array<TransportOptionParameterValue>();

    constructor(option: any) {

        this.id = option?.id;
        this.amountOfPallettes = option?.amountOfPallettes;
        this.amountOfBoxes = option?.amountOfBoxes;
        this.amountInKilogramm = option?.amountInKilogramm;
        this.amountInLiter = option?.amountInLiter;
        this.amountOthers = option?.amountOthers;

        if (option.transportOptions != null) {
            for (const to of option.transportOptions) {
                this.transportOptions.push(new EditTransportOption(to));
            }
        }

        if (option.selectedParameterValues != null) {
            for (const value of option.selectedParameterValues) {
                this.selectedParameterValues.push(new TransportOptionParameterValue(value));
            }
        }
    }
}

export class TransportOptionParameterValue {

    id: number;
    valueDictionaryKey: string;

    constructor(value?: any) {
        if (value != null) {
            this.id = value.id;
            this.valueDictionaryKey = value.valueDictionaryKey;
        }
    }

}